import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "calculation-page" }
const _hoisted_2 = { class: "container-page big" }
const _hoisted_3 = { class: "calculation-page__body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_CalculationStatesLog = _resolveComponent("CalculationStatesLog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      title: _ctx.title,
      dense: ""
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true),
        (_ctx.isShowLog)
          ? (_openBlock(), _createBlock(_component_CalculationStatesLog, {
              key: 0,
              type: _ctx.type,
              isUploadingFile: _ctx.isUploadingFile
            }, null, 8, ["type", "isUploadingFile"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}